import styled from "styled-components";
import Book_SessionSprite from "../../../../images/Book_SessionSprite.svg";
import Success_BgImage from "../../../../images/Success_BgImage.png";
import {CharcoalBlack, DarkSlate, Silver, ErrorRed, White, Teal} from "../../../../theme/variable";
import {media} from "../../../../theme/responsive";
// import Abroad_logo from "../../../../images/Abroad_logo.svg";

export const ConsentFormMainWrapper = styled.div`
    width: 100%;
    margin: ${(props) =>
        props.currentLayer === "digitalConsentFormLayer" ? "0px auto 10px" : "16px auto 10px"};
    padding: 0 12px;
    ${media.laptop`width: 760px;margin: ${(props) =>
        props.currentLayer === "digitalConsentFormLayer"
            ? "0px auto 10px"
            : "20px auto 10px"};padding:0;`}
`;
export const ConsentFormWrapper = styled.div`
    width: 100%;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: ${(props) => (props.successPageNoPadding ? "0" : "12px")};
    h1 {
        font-size: 1.25rem;
        line-height: 23px;
        margin-bottom: 10px;
    }
    p {
        font-size: 1rem;
        line-height: 23px;
        margin-bottom: 8px;
    }
    ${media.laptop`padding: ${(props) => (props.successPageNoPadding ? "0" : "16px")};`}
`;

export const ConsentFormLink = styled.div`
    display: inline-block;
    cursor: pointer;
`;
export const ConsentFormPDFLink = styled.i`
    background: url(${Book_SessionSprite}) no-repeat;
    width: 24px;
    height: 26px;
    background-position: -81px -30px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
`;

export const ConsentTermsCondition = styled.div`
    margin-top: 10px;
    label {
        cursor: pointer;
        font-size: 0.875rem;
        line-height: 20px;
        font-weight: 400;
        margin-left: 5px;
        -webkit-tap-highlight-color: transparent;
    }
    input[type="checkbox"]:checked:after {
        left: 5px;
        top: 2px;
    }
`;

export const ConsentFormField = styled.div`
    width: 100%;
    display: inline-flex;
    align-items: flex-start;
    flex-direction: column;
    vertical-align: top;
    &:nth-child(2n) {
        padding-right: 0;
        ${media.laptop`padding-right: 36px;`}
    }
    &:nth-child(2n + 1) {
        padding-left: 0;
        ${media.laptop`padding-right: 20px;`}
    }
    ${media.laptop`width:50%;position:relative`}
`;
export const ConsentFormButtonPreviewWrapper = styled.div`
    text-align: left;
    width: 100%;
    display: inline-block;
    margin: 36px 0 0px 0;
    button {
        margin-right: 10px;
        padding: 0 35px;
        height: 42px;
        line-height: 42px;
    }
`;
export const ChooseFileToolTipWrapper = styled.div`
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    ${media.laptop`position:unset;`}
`;
export const ChooseFileUploadWrapper = styled.div`
    line-height: 0;
    color: ${DarkSlate};
    margin-top: 18px;
    border: ${(props) => {
        if (props.isError) {
            return `2px solid ${ErrorRed}`;
        } else if (props.isFocused) {
            return `2px solid ${Teal}`;
        }
        return `1px solid ${DarkSlate};`;
    }};
    padding: 10px 20px;
    width: 100%;
    border-radius: 4px;
    position: relative;
    label {
        padding: 0px 12px 0px 13px;
        border-radius: 4px;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14);
        border: solid 1px ${Silver};
        background-color: #ffffff;
        display: inline-block;
        height: 34px;
        line-height: 34px;
        cursor: pointer;
        color: ${CharcoalBlack};
        text-align: center;
        font-weight: 400;
        vertical-align: middle;
        font-size: 0.875rem;
        width: auto;
    }
    input[type="file"] {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
    span {
        display: inline-block;
        margin-left: 10px;
    }
`;

export const ConsentFormFieldsWrapper = styled.div`
    width: 100%;
    strong {
        font-weight: 600;
        font-size: 1.125rem;
        display: block;
        margin-top: 16px;
        margin-bottom: 4px;
        line-height: 24px;
    }
`;
export const ConsentMaxSizeDisclaimer = styled.span`
    margin-top: 10px;
    font-size: 0.75rem;
    color: ${DarkSlate};
    line-height: 18px;
`;
export const RemoveIcon = styled.i`
    background: url(${Book_SessionSprite}) no-repeat;
    width: 23px;
    height: 23px;
    background-position: -66px -1px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
`;

/*PDF Style */
export const ConsentDocWrapper = styled.div`
    margin: 60px auto 20px;
    font-size: 0.9375rem;
    line-height: 23px;
    width: 100%;
    padding: 0 16px;
    p {
        margin-bottom: 10px;
    }
    ul {
        padding-left: 20px;
        margin-top: 10px;
        li {
            margin-bottom: 9px;
        }
    }
    table {
        width: 100%;
        border: 1px solid #999;
        border-collapse: collapse;
        font-size: 0.9375rem;
        tr > th {
            font-weight: 600;
            width: 45%;
            border: 1px solid #999;
            padding: 4px;
            &:first-child {
                width: 10%;
                text-align: center;
            }
        }
        tr > td {
            border: 1px solid #999;
            padding: 4px;
            &:first-child {
                text-align: center;
            }
        }
    }
    ${media.laptop`width: 706px;padding:0;`}
`;
export const ConsentDocHeading = styled.div`
    text-align: center;
    font-size: 1.5rem;
    line-height: 26px;
    margin-bottom: 20px;
    font-weight: 600;
    margin-top: 20px;
    width: 100%;
    display: inline-block;
`;
export const ConsentDocDetailsSection = styled.div`
    margin-top: 16px;
    strong {
        text-align: left;
        font-size: 1.125rem;
        font-weight: 600;
        display: block;
        margin-bottom: 10px;
    }
    span {
        font-weight: 600;
        font-size: 0.875rem;
        display: inline-block;
    }
    a {
        text-decoration: underline;
    }
`;
export const ConsentDocFormDetailSection = styled.div`
    width: 100%;
    display: inline-block;
`;
export const ConsentFormFigure = styled.div`
    width: 140px;
    height: 140px;
    border-radius: 2px;
    border: 2px solid ${DarkSlate};
    display: inline-block;
    margin-top: 10px;
    vertical-align: top;
    margin-right: 10px;
    span {
        font-size: 0.875rem;
        text-align: center;
        display: block;
        padding: 10px;
    }
`;
export const ConsentFormStudentDetails = styled.div`
    display: inline-block;
    width: 100%;
    margin-top: 10px;
    text-align: left;
    padding-left: 0;
    p {
        margin-bottom: 12px;
        label {
            span {
                width: 140px;
                display: inline-block;
                font-size: 0.9375rem;
                color: ${CharcoalBlack};
                ${media.laptop`width: 180px;`}
            }
        }
        strong {
            font-weight: 400;
            display: inline-block;
            width: 52%;
            vertical-align: top;
            ${media.laptop`width:58%;`}
        }
    }
    ${media.laptop`padding-left: 24px;width: 76%;`}
`;
export const ConsentFormDocDisclaimer = styled.div`
    color: ${DarkSlate};
    font-size: 0.75rem;
    text-align: left;
    width: 100%;
    margin: 16px 0;
    line-height: 16px;
`;
export const ConsentAbroadLogo = styled.div`
    width: 100px;
    height: 35px;
    display: inline-block;
    transform: scale(1.2);
    margin: 10px 16px 0 8px;
    float: right;
`;
export const ConsentSignatureUpload = styled.div`
    display: ${(props) => (props.show ? "inline-block" : "none")};
`;
export const ConsentSignatureImage = styled.div`
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    position: relative;
    img {
        width: 42px;
        height: 42px;
        border-radius: 4px;
        display: inline-block;
        border: 1px solid ${DarkSlate};
        vertical-align: middle;
    }
    i {
        position: absolute;
        right: 0;
        top: 10px;
    }
`;
export const DigiSignatureBox = styled.span`
    display: inline-block;
    width: inherit;
    label {
        span {
            width: 140px;
            display: inline-block;
            ${media.laptop`width:180px;`}
        }
    }
    ${media.laptop`width:194px;`}
`;
export const DigiSignature = styled.span`
    color: ${DarkSlate};
    font-size: 0.75rem;
    display: block;
    width: 120px;
    line-height: 16px;
    ${media.laptop`width:auto;`}
`;
export const DigitaleSignatueImage = styled.span`
    display: inline-block;
    vertical-align: top;
    width: 52%;
    img {
        width: 180px;
        height: 140px;
        margin-left: 2px;
        border: 1px solid ${DarkSlate};
        ${media.laptop`width: 320px; height: 140px;`}
    }
    strong {
        font-style: italic;
        text-decoration: underline;
        margin-left: 5px;
        ${media.laptop`margin-left: 2px;`}
    }
    ${media.laptop`width: 58%;`}
`;
export const ConsentSuccessBg = styled.div`
    background: url(${Success_BgImage}) no-repeat;
    width: 100%;
    height: 100px;
    border-radius: 4px 4px 0 0;
    text-align: center;
`;
export const ConsentSuccesText = styled.div`
    text-align: center;
    padding: 16px;
    p {
        font-size: 0.875rem;
        line-height: 20px;
        font-weight: 600;
        margin-bottom: 16px;
    }
`;
export const ConsentSuccessButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    button {
        width: 100%;
    }
    ${media.laptop`
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 16px;
        button {
            width: auto;
        }
    `}
`;
export const ConsentFormDisclaimerText = styled.div`
    font-size: 0.875rem;
    line-height: 21px;
    margin-top: 8px;
    padding: 4px 16px;
    ${media.laptop`padding:4px 0 20px 0;`}
`;
export const ConsentSuccessIcon = styled.i`
    background: url(${Book_SessionSprite}) no-repeat;
    width: 62px;
    height: 88px;
    background-position: ${(props) => (props.consentErrorPosition ? "-80px -59px" : "0 -59px")};
    display: inline-block;
    vertical-align: middle;
    margin-top: 8px;
`;
export const ChooseFileUploadLabel = styled.div`
    background: ${White};
    padding: 2px;
    position: absolute;
    width: ${(props) => (props.chooseFileLabelWidth ? "40px" : "64px")};
    height: 10px;
    top: -6px;
    text-align: center;
    left: 8px;
    color: ${(props) => {
        if (props.isError) {
            return `${ErrorRed}`;
        } else if (props.isFocused) {
            return `${Teal}`;
        }
        return `${CharcoalBlack};`;
    }};
    span {
        font-size: 0.75rem;
        position: absolute;
        top: 4px;
        left: -4px;
    }
`;

export const TopperConsentHead = styled.strong`
    margin-bottom: 12px;
    font-size: 1rem;
    display: block;
`;
export const TopperConsentTitle = styled.strong`
    && {
        margin: 10px 0;
        display: block;
        font-size: 0.9375rem;
    }
`;
